module.exports = __webpack_public_path__ + "img/av_starfish.5fab06a7.png";